import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RazorpayTransactionComponent } from './razorpay-transaction/razorpay-transaction.component';

const routes: Routes = [

  {
    path: '', pathMatch: 'full', redirectTo: 'amount-balance'
  },
  {
    path: 'transaction-details',
    component: RazorpayTransactionComponent
  }
  
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RazorpayRoutingModule { }
